import axios, { CancelToken } from 'axios';
import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 生成访问obs的临时url
export const getSignedurl = (
  data: any,
  cancelToken?: CancelToken,
  isFactory = false
) => {
  // 后端要求这个contentType字段要保证和 singedUrl 上传的 content-type 一致
  data.contentType = data.contentType || 'application/octet-stream';
  const urlStr = isFactory
    ? '/api/wxa/file/getSignedUrl.ac'
    : '/api/admin/common/file/getSignedUrl.ac';
  return request({
    url: `${BASE_URL.scmServer}${urlStr}`,
    method: 'post',
    data,
    cancelToken,
  });
};

// 根据 singnedUrl 保存文件
export const saveFileBySingedUrl = (
  signedUrl: any,
  data: any,
  cancelToken?: CancelToken,
  onUploadProgress?: (progressEvent: ProgressEvent) => void // 添加进度回调
) => {
  return axios({
    url: `${signedUrl}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    data,
    cancelToken,
    onUploadProgress,
  });
};

// 保存文件
export const saveFileInfo = (
  data: any,
  cancelToken?: CancelToken,
  isFactory = false
) => {
  const urlStr = isFactory
    ? '/api/wxa/file/saveFileInfo.ac'
    : '/api/admin/common/file/saveFileInfo.ac';
  return request({
    url: `${BASE_URL.scmServer}${urlStr}`,
    method: 'post',
    data,
    cancelToken,
  });
};
